import { createContext } from "react";
import { iEnquiry } from "../interfaces/iEnquiry";
export const ChangeEnquiryStatusContext = createContext((enquiries: Array<iEnquiry>) => {});
